import { Masonry, Typography } from '@forgeglobal/design-framework';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import AccountDetailsCard from '@tcs/client-portal-common/components/templates/DetailCards/AccountDetailsCard';
import BeneficiariesCard from '@tcs/client-portal-common/components/templates/DetailCards/BeneficiariesCard';
import { useStyles } from '@tcs/client-portal-individual/pages/Accounts/AccountDetails.style';
import { Account } from '@tcs/client-portal-api/types/Account';
import { isDeceasedAccount } from '@tcs/client-portal-common/utils/accountUtils';

interface Props {
  accounts: Account[];
  showBeneficiaries?: boolean;
}

const AccountDetails = ({ accounts, showBeneficiaries = true }: Props) => {
  const classes = useStyles();
  const dynamicColumns = useMasonryDynamicColumns('lg', 2);

  const renderAccounts = accounts.map((account) => {
    const { accountNumber, displayAccountType, effectiveDate, status } =
      account;
    const editEnabled = !isDeceasedAccount(account);
    return (
      <div className={classes.accountDetail} key={accountNumber}>
        <Typography
          variant="h5"
          className={classes.title}
          key={`title${accountNumber}`}>{`${displayAccountType} ${accountNumber}`}</Typography>
        <Masonry numCols={dynamicColumns} key={accountNumber}>
          <AccountDetailsCard
            accountNumber={accountNumber}
            accountType={displayAccountType}
            status={status}
            effectiveDate={effectiveDate}
          />
          {showBeneficiaries && (
            <BeneficiariesCard
              accountNumber={accountNumber}
              editEnabled={editEnabled}
            />
          )}
        </Masonry>
      </div>
    );
  });

  return <>{renderAccounts}</>;
};

export default AccountDetails;
